import { render, staticRenderFns } from "./CollectivePurchase-table.vue?vue&type=template&id=7ae8ff5a&scoped=true"
import script from "./CollectivePurchase-table.vue?vue&type=script&lang=js"
export * from "./CollectivePurchase-table.vue?vue&type=script&lang=js"
import style0 from "./CollectivePurchase-table.vue?vue&type=style&index=0&id=7ae8ff5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae8ff5a",
  null
  
)

export default component.exports